import React, { Component } from 'react';
import $ from "jquery";

/**
 * cid=1_2_3&page=16    翻牌游戏
 */

class AutoFlipFlop extends Component {

    componentDidMount() {
        const { item } = this.props;
        if (item && item.detail && item.detail.id) {
            $(`#${item.detail.id}`).trigger('click');
        }
    }

    render() {
        const { item } = this.props;
        return (
            <div style={{
                "width": "20px",
                "height": "20px",
                "position": "absolute",
                "top": item.detail.tapPoint.y * 100 + "%",
                "left": item.detail.tapPoint.x * 100 + "%",
            }}>

            </div>
        );
    }
}

export default AutoFlipFlop;



// WEBPACK FOOTER //
// ./src/components/review/AutoFlipFlop.js